import React from 'react'
import './../styles/Nav.css'

function Nav(props) {
  const { resetHandler, saveHandler, uploadHandler, downloadHandler } = props

  return (
    <nav>
      <ul>
        <a href="#reset" onClick={(e) => resetHandler(e)}><li>Clear</li></a>
        <a href="#download" style={{marginRight: '1rem'}} onClick={(e) => downloadHandler(e)}><li>Download</li></a>
        <a href="#save" onClick={(e) => saveHandler(e)}><li>Save</li></a>
        <a href="#upload" onClick={(e) => uploadHandler(e)}><li>Upload</li></a>
      </ul>
    </nav>
  )
}


export default Nav
